import React from "react";

import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import { EntityType, MapFilterEntityType } from "@mapmycustomers/shared/types/entity";
import { Button } from "@mapmycustomers/ui";

import styles from "./Footer.module.scss";

const messages = defineMessages<MapFilterEntityType>({
  [EntityType.COMPANY]: {
    id: "map.filters.addRule.company",
    defaultMessage: "+ Add Company Rule",
    description: "Add Rule button type for Company filters on Map page",
  },
  [EntityType.DEAL]: {
    id: "map.filters.addRule.deal",
    defaultMessage: "+ Add Deal Rule",
    description: "Add Rule button type for Deal filters on Map page",
  },
  [EntityType.PERSON]: {
    id: "map.filters.addRule.person",
    defaultMessage: "+ Add Person Rule",
    description: "Add Rule button type for Person filters on Map page",
  },
  universal: {
    id: "map.filters.addRule.universal",
    defaultMessage: "+ Add Universal Rule",
    description: "Add Rule button type for Universal filters on Map page",
  },
});

interface Props {
  addDisabled?: boolean;
  className?: string;
  entityType: MapFilterEntityType;
  onAdd?: () => void;
}

const Footer: React.FC<Props> = ({ addDisabled, className, entityType, onAdd }) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, className)}>
      <Button disabled={addDisabled} onClick={onAdd} size="small" type="default">
        {intl.formatMessage(messages[entityType])}
      </Button>
    </div>
  );
};

export default Footer;
